module.exports = __webpack_public_path__ + "img/ewm.bb04ee87.png";